import styled from 'styled-components';

import { useTheme } from '@/services/theme';
import { breakpoints } from '@/shared/styles';
import { Audits } from '@/shared/contants/Audits';

import Badge from './badge.svg';

const SecurityContainer = styled.section`
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (min-width: ${breakpoints.tabletSM}px) {
    flex-direction: row;
  }

  .Security__badge_container {
    background: rgba(24, 25, 31, 1);
    width: 100%;

    padding: 32px 32px 0 32px;

    @media (min-width: ${breakpoints.tabletSM}px) {
      padding: 116px 0 116px 164px;
      max-width: 400px;
      flex-direction: row;
    }
  }

  .Security__badge {
    width: 175px;
    height: 219px;

    margin: 0 auto;

    background-image: url(${Badge});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    @media (min-width: ${breakpoints.tabletSM}px) {
      width: 350px;
      height: 438px;
    }
  }

  .Security__header_container {
    background: rgba(24, 25, 31, 0.7);
    backdrop-filter: blur(160px);
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 40px;
    grid-column: span 2;

    padding: 32px 16px;

    @media (min-width: ${breakpoints.tabletSM}px) {
      padding: 100px 42px 100px 72px;
      grid-column: span 2;
    }
  }

  .Security__icon_container {
    min-height: 100px;
  }

  .Security__container {
    border: 1px solid #1f2028;
    background: #18191f;
    border-radius: 56px;
    padding: 58px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .Security__title {
    font-size: 36px;
    line-height: 47px;
    font-weight: 700;
    color: #fff;
  }

  .Security__description {
    color: #b4b7cc;
    font-size: 24px;
    font-weight: 400;
    line-height: 36px;
  }

  .Security__description_container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    text-align: left;
    font-family: Gramatika;
  }

  .Security__audits_container {
    width: 100%;
    display: grid;
    gap: 12px;
    grid-template-columns: repeat(2, 1fr);

    @media (min-width: ${breakpoints.tabletMD}px) {
      gap: 16px;
      grid-template-columns: repeat(2, 1fr);
    }
  }

  .Security__audit_container {
    flex: 1;
    width: 100%;
    border: 1px solid #292a35;
    border-radius: 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 0px;

    @media (min-width: ${breakpoints.tabletMD}px) {
      gap: 20px;
      border-radius: 32px;

      & svg {
        height: 42px;
      }
    }

    & svg {
      width: 200px;
      height: 36px;
    }

    &:hover {
      outline: 2px solid rgba(37, 38, 47, 1);
    }
  }

  .Security__audit_logo {
    padding: 12px 0;

    width: 100%;
    max-width: 90px;

    & svg {
      width: 100%;
    }

    @media (min-width: ${breakpoints.tabletMD}px) {
      padding: 24px 0;
      max-width: 150px;
    }
  }
`;

const Link = styled.a`
  width: 100%;
  flex: 1;
  font-family: Gramatika;
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  text-decoration: none;
  color: #18191f;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  transition: opacity 300ms;

  &:focus,
  &:hover {
    opacity: 0.9;
  }
`;

export const Security = () => {
  const { theme } = useTheme();

  return (
    <SecurityContainer>
      <div className="Security__badge_container">
        <div className="Security__badge" />
      </div>

      <div className="Security__header_container">
        <h2>Security First</h2>

        <div className="Security__audits_container">
          {Audits.map((audit, idx) => (
            <Link
              key={`audit_${idx}`}
              href={audit.link}
              target="_blank"
              rel="noreferrer"
              theme={theme}
            >
              <div className="Security__audit_container">
                <div className="Security__audit_logo">{audit.logo}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </SecurityContainer>
  );
};
